import { AfterViewInit, Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "multiple-collections-warning",
  templateUrl: "./multiple-collections-warning.component.html",
  styleUrls: ["./multiple-collections-warning.component.scss"],
  standalone: false,
})
export class MultipleCollectionsWarningComponent implements AfterViewInit {
  constructor(private matDialog: MatDialog) {}

  dialog;

  ngAfterViewInit() {}

  closeDialog() {
    this.dialog = this.matDialog.getDialogById("multiple-collections-dialog");
    this.dialog.close();
  }
}
